module.exports = __webpack_public_path__ + "static/img/shi3_1.3d72f85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shi3_1.png
// module id = tYgs
// module chunks = 1